import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './Input.module.scss';

export const Input = ({
  placeholder,
  value,
  prefix,
  suffix,
  disabled,
  className,
  onChange,
  onPressEnter,
  onFocus,
  onBlur,
}) => {
  const handleChange = e => onChange(e.target.value);
  const handleFocus = e => onFocus(e);
  const handleBlur = e => onBlur(e);
  const handleKeyDown = e =>
    e.keyCode === 13 && onPressEnter(e.target.value.trim());

  return (
    <div className={cn(styles.wrap, className, {[styles.disabled]: disabled})}>
      {prefix && <div className={styles.prefix}>{prefix}</div>}
      <input
        className={styles.input}
        type="text"
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {suffix && <div className={styles.suffix}>{suffix}</div>}
    </div>
  );
};

Input.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onPressEnter: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

Input.defaultProps = {
  placeholder: null,
  value: null,
  prefix: null,
  suffix: null,
  disabled: false,
  className: null,
  onChange: () => null,
  onPressEnter: () => null,
  onFocus: () => null,
  onBlur: () => null,
};
